import { render } from "./StudentProgressPage.vue?vue&type=template&id=e99b42f6&scoped=true&ts=true"
import script from "./StudentProgressPage.vue?vue&type=script&lang=ts"
export * from "./StudentProgressPage.vue?vue&type=script&lang=ts"

import "./StudentProgressPage.vue?vue&type=style&index=0&id=e99b42f6&scoped=true&lang=postcss"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e99b42f6"]])

export default __exports__